module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [(_vm.raceIdToNotification) ? _c('modal-one-signal', {
    attrs: {
      "race-id": _vm.raceIdToNotification
    },
    on: {
      "close-modal": _vm.closeOneSignal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Races")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Create, review and manage scheduled LiveRun race events")])]), _vm._v(" "), _c('router-link', {
    staticClass: "rl-primary-btn",
    attrs: {
      "to": "/admin/races/add",
      "id": "newrace"
    }
  }, [_c('svg', {
    staticClass: "rl-btn-icon",
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14M5 12h14"
    }
  })]), _vm._v("\n      New Race\n    ")])], 1), _vm._v(" "), _c('section', {
    staticClass: "rl-card"
  }, [_c('div', {
    staticClass: "rl-card-header"
  }, [_c('div', {
    staticClass: "rl-header-main"
  }, [_c('span', {
    staticClass: "rl-icon-pill"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 12h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 18h.01"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "rl-card-title"
  }, [_vm._v("Race Schedule")]), _vm._v(" "), _c('p', {
    staticClass: "rl-card-subtitle"
  }, [_vm._v("Track upcoming, active and completed races from one operational list")])])]), _vm._v(" "), _c('span', {
    staticClass: "rl-count-badge"
  }, [_vm._v(_vm._s(_vm.raceRows.length) + " races")])]), _vm._v(" "), _c('div', {
    staticClass: "rl-table-wrap"
  }, [_c('table', {
    staticClass: "rl-table"
  }, [_c('thead', {
    staticClass: "rl-table-head"
  }, [_c('tr', {
    staticClass: "rl-table-row"
  }, [_c('th', {
    staticClass: "rl-th rl-th--name"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "rl-th rl-th--description"
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "rl-th rl-th--duration"
  }, [_vm._v("Duration")]), _vm._v(" "), _c('th', {
    staticClass: "rl-th rl-th--status"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "rl-th rl-th--type"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "rl-th rl-th--date"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "rl-th rl-th--actions"
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "rl-table-body"
  }, [(_vm.racesLoading) ? _vm._l((5), function(n) {
    return _c('tr', {
      key: 'race-skeleton-' + n,
      staticClass: "rl-table-row rl-table-row--skeleton"
    }, [_c('td', {
      staticClass: "rl-td"
    }, [_c('div', {
      staticClass: "rl-sk-line rl-sk-line--name sk-shimmer"
    })]), _vm._v(" "), _c('td', {
      staticClass: "rl-td"
    }, [_c('div', {
      staticClass: "rl-sk-line rl-sk-line--wide sk-shimmer"
    })]), _vm._v(" "), _c('td', {
      staticClass: "rl-td"
    }, [_c('div', {
      staticClass: "rl-sk-line rl-sk-line--short sk-shimmer"
    })]), _vm._v(" "), _c('td', {
      staticClass: "rl-td"
    }, [_c('div', {
      staticClass: "rl-sk-pill sk-shimmer"
    })]), _vm._v(" "), _c('td', {
      staticClass: "rl-td"
    }, [_c('div', {
      staticClass: "rl-sk-line rl-sk-line--medium sk-shimmer"
    })]), _vm._v(" "), _c('td', {
      staticClass: "rl-td"
    }, [_c('div', {
      staticClass: "rl-sk-line rl-sk-line--date sk-shimmer"
    })]), _vm._v(" "), _c('td', {
      staticClass: "rl-td rl-td--actions"
    }, [_c('div', {
      staticClass: "rl-sk-actions sk-shimmer"
    })])])
  }) : (_vm.raceRows.length) ? _vm._l((_vm.raceRows), function(race) {
    return _c('tr', {
      key: race.id,
      staticClass: "rl-table-row"
    }, [_c('td', {
      staticClass: "rl-td rl-td--name"
    }, [_c('span', {
      staticClass: "rl-race-name"
    }, [_vm._v(_vm._s(race.name))])]), _vm._v(" "), _c('td', {
      staticClass: "rl-td rl-td--description"
    }, [_c('span', {
      staticClass: "rl-muted-text"
    }, [_vm._v(_vm._s(race.description || 'No description'))])]), _vm._v(" "), _c('td', {
      staticClass: "rl-td rl-td--duration"
    }, [_vm._v(_vm._s(race.duration) + " minutes")]), _vm._v(" "), _c('td', {
      staticClass: "rl-td rl-td--status"
    }, [_c('span', {
      staticClass: "rl-status-pill",
      class: 'rl-status-pill--' + _vm.getStatusClass(race)
    }, [_vm._v("\n                  " + _vm._s(_vm.getStatusRace(race)) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "rl-td rl-td--type"
    }, [_vm._v(_vm._s(race.type))]), _vm._v(" "), _c('td', {
      staticClass: "rl-td rl-td--date"
    }, [_vm._v(_vm._s(_vm._f("date")(race.date)))]), _vm._v(" "), _c('td', {
      staticClass: "rl-td rl-td--actions"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeRaceId !== race.id || _vm.activeRaceId === 0),
        expression: "activeRaceId !== race.id || activeRaceId === 0"
      }],
      staticClass: "rl-row-actions"
    }, [(race.startDate === null) ? _c('router-link', {
      staticClass: "rl-ghost-btn",
      attrs: {
        "to": {
          path: ("/admin/races/edit/" + (race.id))
        }
      }
    }, [_c('svg', {
      staticClass: "rl-btn-icon",
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
      }
    })]), _vm._v("\n                    Edit\n                  ")]) : _vm._e(), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeRaceId !== race.id),
        expression: "activeRaceId !== race.id"
      }],
      staticClass: "rl-danger-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.handleDelete(race)
        }
      }
    }, [_c('svg', {
      staticClass: "rl-btn-icon",
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2.1",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M3 6h18"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M10 11v6M14 11v6"
      }
    })]), _vm._v("\n                    Delete\n                  ")])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.deleteMode && _vm.activeRaceId === race.id),
        expression: "deleteMode && activeRaceId === race.id"
      }],
      staticClass: "rl-confirmation"
    }, [_c('span', {
      staticClass: "rl-confirmation-text"
    }, [_vm._v("Delete?")]), _vm._v(" "), _c('button', {
      staticClass: "rl-confirm-btn",
      attrs: {
        "type": "button",
        "disabled": _vm.deletingRaceId === race.id
      },
      on: {
        "click": function($event) {
          return _vm.deleteRaceSelected(race, $event)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.deletingRaceId === race.id ? 'Deleting...' : 'Yes') + "\n                  ")]), _vm._v(" "), _c('button', {
      staticClass: "rl-cancel-btn",
      attrs: {
        "type": "button",
        "disabled": _vm.deletingRaceId === race.id
      },
      on: {
        "click": function($event) {
          return _vm.Clear(race)
        }
      }
    }, [_vm._v("No")])])])])
  }) : _vm._e()], 2)]), _vm._v(" "), (!_vm.racesLoading && !_vm.raceRows.length) ? _c('div', {
    staticClass: "rl-empty"
  }, [_c('svg', {
    staticClass: "rl-empty-icon",
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 12h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 18h.01"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "rl-empty-title"
  }, [_vm._v("No races scheduled")]), _vm._v(" "), _c('p', {
    staticClass: "rl-empty-subtitle"
  }, [_vm._v("Create a new race to begin building the LiveRun schedule.")])]) : _vm._e()])]), _vm._v(" "), (_vm.showDebugOptions) ? _c('debug-race-creator') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0581ea60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Races/List.vue
// module id = 1649
// module chunks = 2